import AppModal from "@/components/AppModal";
import AppTextField from "@/components/AppTextField";
import Backdrop from '@mui/material/Backdrop';
import {
  Box,
  Typography,
  Stack,
  styled,
  boxClasses,
  IconButton, TextField
} from '@mui/material'
import AppLoadingButton from '@/components/mui/LoadingButton';
import Fade from '@mui/material/Fade';
import API from "@/constant/API";
import {getCardList} from "@/redux/slices/card";
import {dispatch} from "@/redux/store";
import axiosInstance from "@/utils/axios";
import {isEmptyString} from "@/utils/utils";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import {reportLostCard} from '@/services'
import classes from "./index.module.css";
import {useRequest} from "ahooks";
import styles from "@/components/BindEmailModal/BindEmailModal.module.css";
import RpIcon from "@/components/RpIcon.jsx";

export default function ReportLostModal({
                                          open,
                                          card,
                                          onClose,
                                        }) {
  const {t} = useTranslation();

  const reportLostCardReq = useRequest(async () => {
    const res = await reportLostCard(card.cardId)
    return res
  }, {
    manual: true,
  });

  const onConfirm = () => {
    if (card.available > 0) {
      onClose && onClose()
      return
    }
    onReportLostCard()
  }


  const onReportLostCard = async () => {
    reportLostCardReq.runAsync().then(() => {
      enqueueSnackbar(t('update_successful'), {variant: 'success'})
      onClose && onClose()
    })
  }

  if (!card) return null;

  return (
    <>
      <AppModal open={open} onClose={onClose}
                title={t('set_card_nickname')}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                  backdrop: {
                    timeout: 500,
                  },
                }}
      >
        <Stack direction="column" spacing={2} className={classes.modalContent}
        >
          <Stack className={classes.title} direction="row" justifyContent="space-between">
            <RpIcon icon="close"
                    clickable
                    onClick={() => { onClose && onClose() }}
                    size={20}/>
            <Typography>{t('report_lost_card')}</Typography>
          </Stack>
          <Typography>{t('card_lost_report_alert')}</Typography>
          <AppLoadingButton loading={reportLostCardReq.loading} variant="contained" onClick={onConfirm} fullWidth>
            {t('report_lost_card')}
          </AppLoadingButton>
        </Stack>
      </AppModal>
    </>
  );
}
